import React from 'react';
import { CouponStatusBadge } from './CouponStatusBadge';
import { CouponRowActions } from './CouponRowActions';
import {
  formatExpiresAt,
  formatAppliesTo,
  formatDiscount,
} from '../utils';

// RDT só dispara onRowClicked quando e.target tem data-tag="allowRowEvents"
// (comparação exata, sem subir pela árvore). A célula já traz o atributo; no
// conteúdo customizado, o alvo precisa ser o próprio elemento (data-tag) ou a
// própria célula (filhos com pointer-events: none, que é herdado).
const passClicksToRow = { pointerEvents: 'none' };

export const columns = [
  {
    name: <span className="sr-only">Opções</span>,
    selector: (row) => row.id,
    width: '56px',
    center: true,
    cell: (row) => <CouponRowActions coupon={row} />,
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
  {
    name: 'Nome cupom',
    selector: (row) => row.code,
    minWidth: '120px',
    cell: (row) => (
      <code
        data-tag="allowRowEvents"
        className="items-cell--code items-cell--truncate"
        title={row.code || '-'}
      >
        {row.code || '-'}
      </code>
    ),
  },
  {
    name: 'Data de expiração',
    selector: (row) => row.expiresAt,
    cell: (row) => (
      <div data-tag="allowRowEvents">{formatExpiresAt(row.expiresAt)}</div>
    ),
    width: '180px',
    sortable: true,
    grow: 1.5,
  },
  {
    name: 'Status',
    cell: (row) => (
      <div style={passClicksToRow}>
        <CouponStatusBadge coupon={row} />
      </div>
    ),
    width: '120px',
  },
  {
    name: 'Desconto',
    selector: (row) => formatDiscount(row),
    width: '130px',
  },
  {
    name: 'Aplicável em',
    selector: (row) => formatAppliesTo(row),
    format: (row) => <div style={passClicksToRow}>{formatAppliesTo(row)}</div>,
    minWidth: '160px',
    grow: 1.5,
  },
];
